import querystring from 'query-string';
import _ from 'lodash';

export const removeDuplicates = function (myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

export const currentPath = function () {
  var path = {}
  var stepPath = document.URL.match(/(schritt)-\d/g);
  var stepId = document.URL.match(/(schritt-3)\/\d+/g);
  var verkaufId = document.URL.match(/(verkauf-[1|2])\/\d+/g);

  if (stepPath) { path['step'] = parseInt(stepPath[0].split("-").pop()); }
  if (stepId) { path['id'] = stepId[0].split("/").pop(); }
  if (verkaufId) {
    path['verkaufId'] = verkaufId[0].split("/").shift();
    path['verkaufOrder'] = verkaufId[0].split("/").shift().split("-")[1];
    path['carId'] = verkaufId[0].split("/")[1];
  }

  return path;
}

export const collectUtmParameters = () => {
  const params = new URLSearchParams(document.location.search);
  const SOURCE = 'utm_source';
  const MEDIUM = 'utm_medium';
  const CAMPAIGN = 'utm_campaign';
  const TERM = 'utm_term';

  const utm = {
    SOURCE: 'utm_source',
    MEDIUM: 'utm_medium',
    CAMPAIGN: 'utm_campaign',
    TERM: 'utm_term'
  }

  const result = {};

  for (const key in utm) {
    let cookie_label = utm[key];
    if (params.get(cookie_label)) result[cookie_label] = params.get(cookie_label);
  }

  return result;
}

export const isStagingEnv = () => process.env.VUE_APP_ENV === 'test' || process.env.NODE_ENV === 'development' || window.location.href.includes('test');

export const getSucheLink = (isStaging) => isStaging ? 'https://suche-pkw-test.viscomp.net' : 'https://suche.pkw.de';


function linkToEvaluation(query) {
  const evaluationURL = isStagingEnv() ? 'https://pkw-test.viscomp.net/auto-verkaufen/fahrzeugbewertung/' : "https://pkw.de/auto-verkaufen/fahrzeugbewertung/";
  return `${evaluationURL}?${query}`
};

// function linkToEvaluationLokal (query) {
//   const evaluationURL = isStagingEnv() ? 'https://pkw-test.viscomp.net/auto-verkaufen/fahrzeugbewertung/' : "https://pkw.de/auto-verkaufen/fahrzeugbewertung/";
//   return `${evaluationURL}?${query}`
// };

// function linkToEvaluationOnline (query) {
//   const evaluationURL = isStagingEnv() ? 'https://pkw-test.viscomp.net/auto-verkaufen/fahrzeugbewertung/' : "https://pkw.de/auto-verkaufen/fahrzeugbewertung/";
//   return `${evaluationURL}?${query}`
// };

function linkToVerkaufen(query) {
  const evaluationURL = isStagingEnv() ? 'https://pkw-test.viscomp.net/auto-verkaufen/' : "https://pkw.de/auto-verkaufen/";
  return `${evaluationURL}?${query}`
};

function computeRedirectQueryParameters(store, motivation = 'know_price', lead_source = 'direct', source) {
  const { make, model, year } = store.state.selected;
  const redirect = true;

  const redirectParams = _.omitBy({ make, model, year, motivation, lead_source, source, redirect }, _.isNil);
  return querystring.stringify(redirectParams);
}

export const combineLinkToEvaluation = (store) => {
  const query = computeRedirectQueryParameters(store);
  return linkToEvaluation(query);
}

export const combineLinkToEvaluationNew = (store, callback) => {
  const query = computeRedirectQueryParameters(store);
  return callback(query);
}

export const redirectToEvaluation = (store, redirectToEvaluation = true, motivation = 'know_price', lead_source = 'direct') => {
  const query = computeRedirectQueryParameters(store, motivation, lead_source);

  if (redirectToEvaluation) {
    window.location.href = linkToEvaluation(query);
  } else {
    window.location.href = linkToVerkaufen(query);
  }
}

export const redirectToEvaluationNew = (store, redirectToStation = true, motivation = 'trade_in', lead_source = null) => {

  if (redirectToStation) {
    const query = computeRedirectQueryParameters(store, motivation, lead_source, 'purchase_station');
    window.location.href = linkToEvaluation(query);
  } else {
    const query = computeRedirectQueryParameters(store, motivation);
    window.location.href = linkToEvaluation(query);
  }
}



// WEBPACK FOOTER //
// ./src/services/helpers.js